import React, { useEffect, useState } from 'react'
import { FormControlLabel, Radio, RadioGroup, Typography } from '@material-ui/core'
import { Alert } from '@refera/ui-web'
import * as Modal from '_components/modal/generic-modal'
import { PDF_EXPORT_MODES } from '_/views/inspection-budget/utils/functions'
import useStyles from './styles'

const OPTIONS = [
  { value: PDF_EXPORT_MODES.IDEAL, label: 'Ideal' },
  { value: PDF_EXPORT_MODES.MAXIMUM, label: 'Máximo' },
]

export function PdfExportModeModal({
  openModal,
  setOpenModal,
  defaultMode = PDF_EXPORT_MODES.IDEAL,
  isLoading = false,
  disableDownload = false,
  showMaximumRecommendation = false,
  onConfirm,
}) {
  const styles = useStyles()
  const [selectedMode, setSelectedMode] = useState(defaultMode)

  useEffect(() => {
    if (openModal) {
      setSelectedMode(defaultMode)
    }
  }, [openModal, defaultMode])

  const handleClose = () => {
    if (isLoading) return
    setOpenModal(false)
  }

  const handleConfirm = () => {
    if (isLoading || disableDownload) return
    onConfirm?.(selectedMode)
  }

  const handleSelectionChange = event => {
    setSelectedMode(event.target.value)
  }

  return (
    <Modal.Root open={openModal} onClose={handleClose} className={styles.root}>
      <Modal.TitleModal title="Exportar PDF de orçamento" />
      <Modal.Content className={styles.content}>
        {showMaximumRecommendation && (
          <Alert
            severity="warning"
            title="A cidade selecionada está na lista de exceções. Recomenda-se utilizar o valor máximo."
            className={styles.alert}
          />
        )}
        <Typography className={styles.description}>
          Escolha o parâmetro para gerar o PDF. Você pode alterar essa seleção antes de continuar.
        </Typography>
        <RadioGroup
          value={selectedMode}
          onChange={handleSelectionChange}
          className={styles.radioGroup}
        >
          {OPTIONS.map(option => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio color="primary" />}
              label={option.label}
              className={styles.radioOption}
            />
          ))}
        </RadioGroup>
      </Modal.Content>
      <Modal.Actions>
        <Modal.ButtonRed onClick={handleClose} disabled={isLoading}>
          Cancelar
        </Modal.ButtonRed>
        <Modal.ButtonFullBlue onClick={handleConfirm} disabled={isLoading || disableDownload}>
          Baixar PDF
        </Modal.ButtonFullBlue>
      </Modal.Actions>
    </Modal.Root>
  )
}
